/**
 * FlowsSidePanel — columna derecha de la ventana de entrada.
 *
 * Es 100% presentacional: explica la creación por flujos con los nombres
 * REALES de los nodos del panel de herramientas y ofrece la salida directa al
 * Studio. El único comportamiento es `onExit`, que cierra el overlay (no
 * reinicia el proyecto ni recarga el editor).
 */
import { ChevronRight, Workflow } from 'lucide-react';

// Nombres tal cual aparecen en el panel de herramientas del Studio.
const PALETTE = [
  'Mejorar Imagen',
  'Nano Banana',
  'Crear Video',
  'Video con Sonido',
  'Upscale',
  'Style Transfer',
  'Remover Fondo',
];

const STEPS = [
  'Seleccioná las herramientas desde el panel',
  'Arrastrá y conectá los bloques en el lienzo',
  'Configurá, ejecutá y obtené resultados',
];

const FlowsSidePanel = ({ onExit }) => (
  <aside className="flowspanel" data-testid="flows-side-panel">
    <header className="flowspanel-head">
      <span className="flowspanel-tile"><Workflow size={20} /></span>
      <div>
        <h2>Creación por flujos</h2>
        <p>Construí visualmente con bloques</p>
      </div>
    </header>

    <p className="flowspanel-lead">
      Una forma más visual y avanzada de crear. Arrastrá herramientas, conectá
      bloques y diseñá tu flujo paso a paso.
    </p>

    <ol className="flowspanel-steps">
      {STEPS.map((text, i) => (
        <li key={text}>
          <span className="flowspanel-step-num">{i + 1}</span>
          <span>{text}</span>
        </li>
      ))}
    </ol>

    <div className="flowspanel-demo" aria-hidden>
      <div className="flowspanel-demo-palette">
        <span className="flowspanel-demo-title">HERRAMIENTAS</span>
        <span className="flowspanel-demo-search">Buscar herramienta…</span>
        {PALETTE.map((name, i) => (
          <span key={name} className={`flowspanel-demo-tool ${i === 1 ? 'is-picked' : ''}`}>
            <i className="flowspanel-demo-dot" />
            {name}
          </span>
        ))}
      </div>

      <div className="flowspanel-demo-canvas">
        <span className="flowspanel-demo-hint">Arrastrá, conectá y creá tu flujo</span>
        <div className="flowspanel-demo-node n1">Nano Banana</div>
        <div className="flowspanel-demo-node n2">Crear Video</div>
        <div className="flowspanel-demo-node n3">Mejorar Imagen</div>
        <svg className="flowspanel-demo-wires" viewBox="0 0 220 170" preserveAspectRatio="none">
          <path d="M78 42 C 110 42, 118 66, 148 66" />
          <path d="M168 92 C 168 112, 140 116, 118 128" />
        </svg>
      </div>
    </div>

    <button
      type="button"
      className="flowspanel-cta"
      onClick={onExit}
      data-testid="lumiere-goto-flows"
    >
      <Workflow size={16} />
      <span>Creación por flujos</span>
      <ChevronRight size={16} />
    </button>
  </aside>
);

export default FlowsSidePanel;
